<template>
  <div>
    <div>
      <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
      <h3 class="mt-3">
        {{
          $getVisibleNames(
            "mesh.studyenvironment",
            true,
            "Ambientes de Aprendizajes"
          )
        }}
        <AlternativeNameButton
          :table_name="'mesh.studyenvironment'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_studyenvironment'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.studyenvironment',
                  false,
                  'Ambiente de Aprendizaje'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-study-environment-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
      </div>
      <GenericBTable
        class="study-environment-table"
        :items="study_environments"
        :pagination="10"
        :fields="studyEnvironmentsFields"
        :filterCustom="filterCustom"
        @emitChangeSearchField="changeInputSearch"
        :filter="input_search"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(time_allocation)="row">
          <div class="time-allocation-container">
            <div
              v-for="item in getTimeAllocation(row.item.id)"
              :key="item.id"
              class="kl-chip"
            >
              {{ item.name }}
            </div>
          </div>
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.studyenvironment',
                  false,
                  'Ambiente de Aprendizaje'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-study-environment-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            :click_button="() => askForDeleteStudyEnvironment(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.studyenvironment',
                  false,
                  'Ambiente de Aprendizaje'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-study-environment-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.studyenvironment',
                  false,
                  'Ambiente de Aprendizaje'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <StudyEnvironmentForm
              :StudyEnvironment="row.item"
              @updated="slotUpdatedStudyEnvironment"
              :show_title="false"
            ></StudyEnvironmentForm>
          </b-modal>
        </template>
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-study-environment-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.studyenvironment',
            false,
            'Ambiente de Aprendizaje'
          ),
        })
      "
      size="lg"
    >
      <StudyEnvironmentForm
        @created="slotCreatedStudyEnvironment"
        :show_title="false"
      ></StudyEnvironmentForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";
export default {
  name: "StudyEnvironmentView",
  components: {
    StudyEnvironmentForm: () =>
      import(
        "@/components/mesh/CurricularResources/StudyEnvironment/StudyEnvironmentForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      input_search: "",
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      studyEnvironmentsTimeAllocation: names.STUDY_ENVIRONMENTS_TIME_ALLOCATION,
      time_allocations: names.TIME_ALLOCATIONS,
      study_environments: names.STUDY_ENVIRONMENTS,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.studyenvironment",
            true,
            "Ambientes de Aprendizajes"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_studyenvironment");
      if (has_permission) return has_permission;
      else return false;
    },
    study_environments_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.studyenvironment",
              true,
              "Ambientes de Aprendizajes"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "time_allocation",
          label: this.$getVisibleNames(
            "mesh.timeallocation",
            true,
            "División de tiempo"
          ),
          sortable: true,
          // time_allocation no existe en el item: la celda arma los chips aparte
          sortByFormatted: (value, key, item) =>
            this.getTimeAllocation(item.id)
              .map((x) => x.name)
              .join(", "),
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
    studyEnvironmentsFields() {
      if (!this.allows_crud)
        return this.study_environments_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.study_environments_fields;
    },
  },
  methods: {
    filterCustom(row) {
      if (
        this.$filtered(row.name, this.input_search) ||
        this.$filtered(row.description, this.input_search) ||
        this.time_allocations.filter(
          (x) =>
            this.$filtered(x.name, this.input_search) &&
            this.studyEnvironmentsTimeAllocation.find(
              (sETA) =>
                sETA.time_allocation == x.id && sETA.study_environment == row.id
            )
        ).length > 0
      ) {
        return true;
      } else return false;
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    getTimeAllocation(study_environment_id) {
      const time_allocation_ids = [
        ...new Set(
          this.studyEnvironmentsTimeAllocation
            .filter((x) => x.study_environment == study_environment_id)
            .map((x) => x.time_allocation)
        ),
      ];
      return this.time_allocations.filter((x) =>
        time_allocation_ids.includes(x.id)
      );
    },
    askForDeleteStudyEnvironment(study_environment_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.studyenvironment",
            false,
            "Ambiente de Aprendizaje"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_STUDY_ENVIRONMENT, study_environment_id)
            .then(() => {
              toast(
                this.$t("reusable.common.deletedSuccessfully", {
                  entity: this.$getVisibleNames(
                    "mesh.studyenvironment",
                    false,
                    "Ambiente de Aprendizaje"
                  ),
                })
              );
            });
        }
      });
    },
    slotCreatedStudyEnvironment() {
      this.$bvModal.hide("new-study-environment-modal");
    },
    slotUpdatedStudyEnvironment(study_environment) {
      this.$bvModal.hide(
        `edit-study-environment-modal-${study_environment.id}`
      );
    },
  },
  mounted() {
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS_TIME_ALLOCATION);
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS);
    this.$store.dispatch(names.FETCH_TIME_ALLOCATIONS);
  },
  created() {},
};
</script>

<style scoped>
.td-actions {
  max-width: 100px !important;
}
.title-header {
  padding: 0 1rem;
  margin-top: auto;
}
.search-study-environment {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
.time-allocation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  gap: 3px;
}
</style>